import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageServerAction } from '../coverageServer.action';
import { CoverageServerTranslator } from '../coverageServer.translator';

type IDependencies = ICoverageApiDependencySegment;

export const updateCoverageServerEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageServerAction.update.started),
  mergeMap((params) => {
    const { payload, resolve } = params;

    return coverageApi.updateCoverageServer(payload.serverId, CoverageServerTranslator.toApi(payload)).pipe(
      mergeMap(() => {
        resolve(payload.serverId);
        return [CoverageServerAction.update.done({ params })];
      }),
      catchApiError((error) => [
        CoverageServerAction.update.failed({ params, error }),
        createApiErrorNotification(error),
      ]),
    );
  }),
);
